// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toggle {
  padding-right: 0;
}

.container-list {
  height: 100%;
  width: 100%;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/list-selectable/list-notifications/list-notifications.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;EACA,cAAA;AACJ","sourcesContent":["ion-toggle {\n    padding-right: 0;\n}\n\n.container-list{\n    height: 100%;\n    width: 100%;\n    overflow: auto;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
